var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10999_95156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.725 8.22473L20.7676 18.2198C20.8653 18.3447 20.9181 18.4971 20.9184 18.6546C20.919 19.0346 20.6171 19.3451 20.2396 19.3583L20.2271 19.3608L20.2071 19.3583L1.76962 19.3908C1.50712 19.3913 1.26937 19.2467 1.14896 19.0144C1.02605 18.7821 1.04306 18.5046 1.19268 18.2893L5.79098 11.6487C5.91068 11.4785 6.09798 11.3682 6.30545 11.3503C6.51042 11.3325 6.71055 11.4021 6.8583 11.5443L8.81369 13.1834L12.3224 8.17971L12.3205 7.10221L7.89798 7.11C7.51048 7.11069 7.19493 6.79624 7.19424 6.40874L7.18882 3.33375C7.18814 2.94625 7.50258 2.63069 7.89008 2.63001L13.0151 2.62098C13.4001 2.6203 13.7156 2.93474 13.7163 3.32224L13.725 8.22473Z",
    fill: "#458C0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10999_95156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.961914 1.01733) rotate(-0.101015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionActive);
export default __webpack_public_path__ + "static/media/mission_active.2ea9c995beec59239615014d33182939.svg";
export { ForwardRef as ReactComponent };